import { Avatar, Button, TextField, Grid, Box, Typography, Paper, Alert } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { json, Form, Link, useLoaderData, useActionData, useLocation } from 'react-router-dom';
import intl from 'react-intl-universal';
import { Routes } from '../Routes';
import Copyright from '../components/Copyright';
import PasswordInput from '../components/PasswordInput';

export async function SignInLoader({ params }) {
  const data = { companyName: params.companyName };
  return json(data, { status: 200 });
}

export const SignInAction = (auth) =>
  async ({ request }) => {
    const data = Object.fromEntries(await request.formData());
    const response = await auth.login(data);

    if (response?.ok) {
      return new Response("", {
        status: 302,
        headers: {
          Location: Routes.schedule,
        },
      });
    } else {
      return response;
    }
  }

export default function SignIn() {
  const data = useLoaderData();
  const errors = useActionData();
  const location = useLocation();
  const { state } = location;
  
  return (
    <Grid container component="main" sx={{ height: '100vh' }}>
      <Grid
        item
        xs={false}
        sm={4}
        md={7}
        sx={{
          backgroundImage: 'url(images/winter_road.jpg)',
          backgroundRepeat: 'no-repeat',
          backgroundColor: (t) =>
            t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />

      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <Box
          sx={{
            my: 8,
            mx: 4,
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            {intl.get('signin').d('Sign In')}
          </Typography>
          <Box sx={{ mt: 1 }}>
            {errors?.error && (
              <Alert severity="error" sx={{ width: '100%' }}>
                {errors.error}
              </Alert>
            )}
            {state?.message && (
              <Alert severity="success" sx={{ width: '100%' }}>
                {state.message}
              </Alert>
            )}
            <Form method="post">
              <TextField
                margin="normal"
                required
                fullWidth
                id="userName"
                name="userName"
                label={intl.get('emailaddress').d('Email address')}
                autoComplete="email"
                autoFocus
              />  
             <PasswordInput
                  margin="normal"
                  required
                  fullWidth
                  id="password"
                  name="password"
                  label={intl.get("password").d("Password")}
                  autoComplete="current-password"
                  defaultValue=""
              />
              <div hidden>
                <TextField
                  readOnly
                  margin="normal"
                  required
                  fullWidth
                  name="isClient"
                  id="isClient"
                  type="hidden"
                  value={true}
                />
              </div>
              <div hidden={!!data.companyName}>
                <TextField
                  readOnly={!!data.companyName}
                  margin="normal"
                  required
                  fullWidth
                  name="companyName"
                  id="companyName"
                  label={intl.get('company').d('Company')}
                  type={data.companyName ? 'hidden' : 'text'}
                  defaultValue={data.companyName ? data.companyName : ''}
                />
              </div>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                {intl.get('signin').d('Sign In')}
              </Button>
            </Form>
            <Grid container>
              <Grid item xs>
 				<Link
				  to={data?.companyName ? `${Routes.resetPassword}/${data.companyName}` : Routes.resetPassword}
				  variant="body2"
				>             
                  {intl.get('forgotpassword').d('Forgot password?')}
                </Link>
              </Grid>
              <Grid item>
				<Link
				  to={data?.companyName ? `${Routes.signUp}/${data.companyName}` : Routes.signUp}
				  variant="body2"
				>
                  {intl.get('donthaveanaccountsignup').d(`Don't have an account? Sign up.`)}
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Grid>
    </Grid>
  );
}